import React from 'react'
import { View } from 'react-native'
import { StyleService, useStyleSheet } from '@style/service.ts'
import { Text } from '@src/components/base'

export interface PromoTagProps {
  amountSaved?: string
}

export const PromoTag = (props: PromoTagProps) => {
  const styles = useStyleSheet(themedStyle)
  const { amountSaved } = props

  return (
    <View style={styles.container}>
      <Text type="tiny" style={styles.text} adjustsFontSizeToFit numberOfLines={1}>
        Limited Offer{amountSaved ? `: Save ${amountSaved}` : ''}
      </Text>
    </View>
  )
}

const themedStyle = StyleService.create({
  container: {
    alignItems: 'center',
    padding: 2,
    paddingHorizontal: 8,
    borderRadius: 16,
    height: 30,
    justifyContent: 'center',
    borderWidth: 2,
    backgroundColor: 'theme.surface.base4',
    borderColor: 'theme.surface.baseYellow',
    elevation: 2, // For Android shadow
    shadowColor: 'theme.warning.medium', // For iOS shadow
    shadowOffset: { width: 0, height: 0 },
    shadowOpacity: 1,
    shadowRadius: 4,
  },
  text: {
    color: 'theme.warning.darkest',
    fontWeight: '700',
  },
})
